//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <DIV class='content-wrapper'>
  <div v-if="serverData.loadingDataStatus.mainCommonData != serverData.loadingDataStatus.types.LOADED" class="loading-text">
    Подождите, загружаются общие данные
  </div>
  <div v-else-if="serverData.loadingDataStatus.events != serverData.loadingDataStatus.types.LOADED" class="loading-text">
    Подождите, загружаются данные по событиям
  </div>
  <div v-else-if="event == null" style="width:100%; float:left">
    <div @click="close()"><i class="fas fa-arrow-circle-left back-button"></i></div>
    <div class="eventnotfound-text">Событие не найдено или устарело</div>
  </div>
  <div v-else class="event">

    <DIV class="event_part1">

    <div class="event-image" :style="{'background-image': 'url(' + serverData.imagesGetURL(event.val.body.images[0]) + ')'}" @click="close()">
      <i class="fas fa-arrow-circle-left back-button-over"></i>
      <i v-if="isActiveUserOwnerOfEventOrAdmin()" class="fas fa-edit back-button-over-right" @click="goToEventEdit(event.val.id)"></i>
    </div>

    <div style="width:100%; padding:10px 0 0 0; float:left;">
      <div class="event-name">{{event.val.name}}</div>
    </div>

    <div style="width:100%; padding:10px 0 0 0; float:left;">
      <div class="event-status" :style="{'background' : getEventStatusBackground()}" v-if="event.val.status != 1">
        {{getEventStatusText()}}<br>по причине: {{event.val.body.cancelReason}}
      </div>
    </div>

    <div style="width:100%; padding:10px 0 0 0; text-align:left; float:left;">
      <div class="event-prop link" @click="goToUserCard(event.val.createdBy)">
        <div class="event-user-avatar" :style="{'background-image': 'url(' + serverData.imagesGetURL(getUser(event.val.createdBy).body.avatar) + ')'}">&nbsp;</div>
        <div style="width:calc(100% - 70px); padding-top:10px; float:right">
          Организатор:<br>
          {{getUser(event.val.createdBy).name}}<br>
          <span v-if="getUser(event.val.createdBy).phone != null" style="font-size:11px"> (+{{getUser(event.val.createdBy).phone}})</span>
        </div>
      </div>
    </div>

    <div style="width:100%; padding:10px 0 0 0; text-align:left; float:left;">
      <div class="event-prop link" @click="goToPlaceCard(event.val.place)">
        <div class="event-place-image" :style="{'background-image': 'url(' + serverData.imagesGetURL(serverData.placesMap[event.val.place].val.images[0]) + ')'}">&nbsp;</div>
        <div style="width:calc(100% - 70px); float:left">
          Место:<br>
          {{serverData.placesMap[event.val.place].val.name}}<br>
          {{serverData.placesMap[event.val.place].val.city}}, {{serverData.placesMap[event.val.place].val.address}}
        </div>
      </div>
    </div>

    <div style="width:50%; padding:0px 0 0 0; text-align:left; float:left;">
      <div class="event-prop" style="padding-top:20px">
        Дата: {{event.val.dateStart | formatDate('date + weekday')}}
      </div>
      <div class="event-prop">
        Время: {{event.val.timeStart}} - {{event.val.timeEnd}}
      </div>
    </div>

    <div style="width:50%; padding:0px 0 0 0; text-align:right; float:left;">
      <!--div class="event-prop" style="padding-top:20px">Сложность: {{event.val.level}}/5</div-->
      <div class="event-prop" style="padding-top:42px" v-if="event.val.price > 0">Стоимость: {{event.val.price}} р</div>
      <!--div class="event-prop">Тэги: {{event.val.tags}}</div-->
    </div>

    <div style="width:calc(100% - 50px); margin:20px 25px 0 25px; background:#f9f9f9; border-radius:10px; float:left;">
      <div class="event-prop" style="padding:15px 20px 20px 20px;" id="eventDescription">&nbsp;</div>
    </div>

    </DIV>

    <DIV class="event_part2" style="padding:0 25px 0 25px; text-align:center" v-if="activeUser == null">
      Войдите в систему, чтобы принять участие в событии
    </DIV>

    <DIV class="event_part2" v-if="(activeUser != null)">

      <Button v-if="((eventMembering.myMembering == null) || (eventMembering.myMembering.val.status != 1) || (eventMembering.myMembering.val.participationType == 2))" type="primary" size="large" class="button-primary" @click="subscribe(1)">Участвую</Button>
      <Button v-if="((eventMembering.myMembering == null) || (eventMembering.myMembering.val.status != 1) || (eventMembering.myMembering.val.participationType == 1))" type="primary" size="large" class="button-primary" @click="subscribe(2)">Возможно</Button>
      <Button v-if="((eventMembering.myMembering != null) && (eventMembering.myMembering.val.status == 1))" type="ghost" size="large" class="button-primary" style="color:#fff; background:#777;" @click="unsubscribe()">Не участвую</Button>

      <div style="width:100%; padding:0px 0 20px 0;float:left;">
        <div class="event-prop">
          <span style="font-size:16px; font-weight:600;">Участников:</span> {{event.membering.members.length}} <span v-if="event.membering.possible.length > 0">(+{{event.membering.possible.length}} возможно)</span> (мин: {{event.val.body.membersLimitFrom}} макс: {{event.val.body.membersLimitTo}})
        </div>
      </div>

      <DIV v-if="event.membering.members.length > 0" style="width:100%; margin-bottom:20px; float:left;">
      <div class="event-member" style="font-weight:600; margin:0px 0 5px 0;">Участники:</div>
      <div v-for="(eventMember, keyM) in event.membering.members" :key="keyM" class="event-member link" @click="goToUserCard(eventMember.val.refToUser)">
        <div class="event-user-avatar-small" :style="{'background-image': 'url(' + serverData.imagesGetURL(getUser(eventMember.val.refToUser).body.avatar) + ')'}">&nbsp;</div>
        <div class="event-user-text" :style="{'padding-top': isActiveUserOwnerOfEventOrAdmin() ? '4px' : '11px'}">
          {{getUser(eventMember.val.refToUser).name}}<br>
          <span v-if="(eventMember.val.refToUser != activeUser.id) && (getUser(eventMember.val.refToUser).phone != null)" style="font-size:11px">+{{getUser(eventMember.val.refToUser).phone}}</span>
          <span v-if="isActiveUserOwnerOfEventOrAdmin()" style="font-size:11px">, {{eventMember.val.price}} р</span>
          <span v-if="isActiveUserOwnerOfEventOrAdmin()" style="font-size:11px">, {{eventMember.val.participated == true ? 'участвовал' : 'не участвовал'}}</span>
        </div>
      </div>
      </DIV>

      <DIV v-if="event.membering.possible.length > 0" style="width:100%; margin-bottom:20px; float:left;">
      <div class="event-member" style="font-weight:600; margin:0px 0 5px 0;">Возможно:</div>
      <div v-for="(eventMember, keyP) in event.membering.possible" :key="keyP" class="event-member link" @click="goToUserCard(eventMember.val.refToUser)">
        <div class="event-user-avatar-small" :style="{'background-image': 'url(' + serverData.imagesGetURL(getUser(eventMember.val.refToUser).body.avatar) + ')'}">&nbsp;</div>
        <div class="event-user-text" :style="{'padding-top': isActiveUserOwnerOfEventOrAdmin() ? '4px' : '11px'}">
          {{getUser(eventMember.val.refToUser).name}}<br>
          <span v-if="(eventMember.val.refToUser != activeUser.id) && (getUser(eventMember.val.refToUser).phone != null)" style="font-size:11px">+{{getUser(eventMember.val.refToUser).phone}}</span>
          <span v-if="isActiveUserOwnerOfEventOrAdmin()" style="font-size:11px">, {{eventMember.val.price}} р</span>
          <span v-if="isActiveUserOwnerOfEventOrAdmin()" style="font-size:11px">, {{eventMember.val.participated == true ? 'участвовал' : 'не участвовал'}}</span>
        </div>
      </div>
      </DIV>

      <DIV v-if="event.membering.cancels.length > 0" style="width:100%; margin-bottom:20px; float:left;">
      <div class="event-member" style="font-weight:600; margin:0px 0 5px 0;">Отмененные участия:</div>
      <div v-for="(eventMember, keyC) in event.membering.cancels" :key="keyC" class="event-member link" @click="goToUserCard(eventMember.val.refToUser)">
        <div class="event-user-avatar-small" :style="{'background-image': 'url(' + serverData.imagesGetURL(getUser(eventMember.val.refToUser).body.avatar) + ')'}">&nbsp;</div>
        <div class="event-user-text" :style="{'padding-top': isActiveUserOwnerOfEventOrAdmin() ? '4px' : '11px'}">
          {{getUser(eventMember.val.refToUser).name}}<br>
          <span v-if="(eventMember.val.refToUser != activeUser.id) && (getUser(eventMember.val.refToUser).phone != null)" style="font-size:11px">+{{getUser(eventMember.val.refToUser).phone}}</span>
          <span v-if="isActiveUserOwnerOfEventOrAdmin()" style="font-size:11px">, {{eventMember.val.price}} р</span>
          <span v-if="isActiveUserOwnerOfEventOrAdmin()" style="font-size:11px">, {{eventMember.val.participated == true ? 'участвовал' : 'не участвовал'}}</span>
        </div>
      </div>
      </DIV>

    </DIV>

    <!-- placeToMeet createdBy dateEnd body.deadlineToUnsub body.paymentsTypes | status tags-->

  </div>

  </DIV>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

// import http from 'axios'

import serverData from '@/store/serverData'

import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

export default {
  components: { },
  props: ['id'],
  data () {
    return {
      eventId: null,
      event: null,
      eventMembering: {
        myMembering: null,
        subscribingIsProcessingOnServer: false
      },
      serverData: serverData // to make access from UI template
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'activeUser'
    ])
  },
  created: function () {
    var thisRef = this
    this.eventId = this.id
    if (typeof this.eventId === 'string') this.eventId = parseInt(this.eventId) // integer если приходят из ленты и это первый раз и вызывается create. string если это первая страница приложения после f5

    // загружаем данные, когда представление создано и данные реактивно отслеживаются
    this.setEventData()
    this.setMyMembering()
    // подписываемся на загрузку основных данных - когда эта страница это та на которой стартует приложение и на момент created данные еще не подгрузились
    serverData.eventsBus.$on('mainCommonDataLoaded', function () {
      thisRef.setEventData()
      thisRef.setMyMembering()
    })
    // на realtime обновления events подписываемся на случай если кто-то обновил именно это событие
    serverData.eventsBus.$on('eventsChanged', function (data) {
      // вызов этого обработчика будет и пока грузятся основные данные через mainCommonDataLoader что уже обрабатывается
      // через подписку на $on('mainCommonDataLoaded') и второй обработки events нам не надо
      if (data.initiator !== 'realtimeServerDataManager') return
      if (data.record.id !== this.eventId) return // другие типы объектов кроме event не придут. и тут на случай если пришло через realtimeServerDataManager обновление но event с другим id
      thisRef.setEventData(data)
      // setMyMembering() не надо ибо оно не меняется если поменялись какие-то поля у события
    })
    serverData.eventsBus.$on('eventsMembersChanged', function (data) {
      // вызов этого обработчика будет и пока грузятся основные данные через mainCommonDataLoader что уже обрабатывается
      // через подписку на $on('mainCommonDataLoaded') и второй обработки events нам не надо
      if (data.initiator !== 'realtimeServerDataManager') return
      thisRef.setMyMembering(data)
    })
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова. а если сначала смотрели /event/1, ушли, и снова смотрим но /event/2 то кроме как через watch route больше об этом не узнать
    // data - объект route из watch route. пример = {name:'place', path:'/place/1', params:{id:1}}
    $route: function (data) {
      // console.log('event.route')
      // console.log(data)
      if (data.name !== 'event') return // на случай если это вызов через watch route когда ушли со страницы
      this.eventId = this.id // надо чтоб отработать если показываем следующее событие (роут поменялся)
      this.setEventData(data)
      this.setMyMembering(data) // чтобы обновить myMembering иначе останется равным для предыдущего просматриваемого события
    },
    // чтобы отобразить description с /n нельзя использовать vue.filter потому что там <br> не превращаются в тэги (остаются строкой), а <pre> не переносит слова, а переносит
    // прерывая посреди слова. использовать v-html очень опасно(можно заменить все начала тэгов < и концы > на пробелы, чтоб не баловались с html и <script> но чет
    // не хочется экспериментов. innerText заменяет /n на <br>
    // но из-за того данные обновляются отдельно от DOM, то в момент этого watch наш DOM может перестариваться и не иметь элемента eventDescription. поэтому запускаем settimeout пока не установим значение
    'event.val.description': function (data) {
      var thisRef = this
      function setEventDescription () {
        var el = document.getElementById('eventDescription')
        if (el != null) el.innerText = thisRef.event.val.description + ' '
        else setTimeout(setEventDescription, 1)
      }
      setTimeout(setEventDescription, 1)
    }
  },
  methods: {
    // data - это или route или объект из realtimeServerDataManager  {method:'update', type:'event', record:{id, name...}, initiator: "realtimeServerDataManager"}
    setEventData (data) {
      // console.log('setEventData')
      var anEvent = serverData.eventsMap[this.eventId]
      if (anEvent == null) { /* console.log('Event.getPlaceData: common data not loaded. exit'); */ return } // это происходит при перезагрузки страницы, данные еще не пришли с сервера
      this.event = Object.assign({}, anEvent)
      // this.event.val = Object.assign({}, anEvent.val)
      // this.event.val.body = Object.assign({}, anEvent.val.body)
    },
    setMyMembering (data) {
      this.eventMembering.myMembering = null
      if (this.activeUser == null) return
      for (var i = 0; i < this.serverData.eventsMembers.length; i++) {
        var eventMember = this.serverData.eventsMembers[i]
        if ((eventMember.val.refToEvent === this.eventId) && (eventMember.val.refToUser === this.activeUser.id)) this.eventMembering.myMembering = eventMember
      }
    },
    getEventStatusText () {
      switch (this.event.val.status) {
        case 1: return 'Опубликовано'
        case 10: return 'Снято с публикации автором'
        case 11: return 'Снято с публикации админом'
        case 12: return 'Событие ЗАБАНЕННО админом'
        default: return 'Неизвестный статус события'
      }
    },
    getEventStatusBackground () {
      switch (this.event.val.status) {
        case 1: return '#888'
        case 10: return '#db3'
        case 11: return '#d33'
        case 12: return '#f00'
        default: return '#f00'
      }
    },
    getUser (userId) {
      if (this.serverData.usersMap[userId] != null) return this.serverData.usersMap[userId]
      else {
        var anUser = {id: userId, name: 'Участник...', phone: null, body: {}}
        this.serverData.users.push(anUser)
        this.serverData.usersMap[anUser.id] = anUser
        return anUser
      }
    },
    isActiveUserOwnerOfEventOrAdmin () {
      if (this.activeUser == null) return false
      if (this.activeUser.id === this.event.val.createdBy) return true // если activeUser это орг события
      if ((this.activeUser.group === 0) || (this.activeUser.group === 1)) return true // суперпользователь или админ
      return false
    },
    subscribe (participationType) {
      if (this.eventMembering.subscribingIsProcessingOnServer === true) return // выходим если предыдущая команда еще обрабатывается на сервере. чтоб нельзя было два раза нажать на кнопку
      this.eventMembering.subscribingIsProcessingOnServer = true

      if (this.eventMembering.myMembering !== null) {
        var eventMember = this.eventMembering.myMembering
        eventMember.val.participationType = participationType
        eventMember.val.status = 1
      } else {
        eventMember = restResource(this.appSettings.server.eventMemberResource)
        eventMember.val = {}
        eventMember.val.refToEvent = this.eventId
        eventMember.val.refToUser = this.activeUser.id
        eventMember.val.participationType = participationType
        eventMember.val.status = 1
        eventMember.val.participated = false
        eventMember.val.price = this.event.val.price
        eventMember.val.body = {}
      }

      var thisRef = this
      eventMember.save()
      .then(function (response) {
        thisRef.eventMembering.subscribingIsProcessingOnServer = false
      })
      .catch(function (error) {
        thisRef.eventMembering.subscribingIsProcessingOnServer = false
        serverErrorHandling(error, thisRef)
      })
    },
    unsubscribe () {
      if (this.eventMembering.myMembering == null) return // но этой ошики быть не может потому что кнопка с методом доступна только если это поле не null
      var myEventMembering = this.eventMembering.myMembering
      myEventMembering.val.status = 2 // cancel by user

      if (this.eventMembering.subscribingIsProcessingOnServer === true) return // выходим если предыдущая команда еще обрабатывается на сервере. чтоб нельзя было два раза нажать на кнопку
      this.eventMembering.subscribingIsProcessingOnServer = true

      var thisRef = this
      myEventMembering.save()
      .then(function (response) {
        thisRef.eventMembering.subscribingIsProcessingOnServer = false
      })
      .catch(function (error) {
        thisRef.eventMembering.subscribingIsProcessingOnServer = false
        serverErrorHandling(error, thisRef)
      })
    },
    goToUserCard (id) {
      this.$router.push({name: 'user', params: {id: id}})
    },
    goToPlaceCard (id) {
      this.$router.push({name: 'place', params: {id: id}})
    },
    goToEventEdit (id) {
      this.$router.push({name: 'event-edit', params: {id: id}})
    },
    close () {
      if (this.$router.app._route.name !== 'event') return // это значит что уже перешли куда-то типа place-edit и это close лишнее с обработки картинки а не иконки назад и history.back делать не надо
      // 2 - это значит пустая страница + текущая с продуктом. или 1 - сразу из внешнего приложения открылась эта страница
      if (history.length <= 2) window.location.href = '/' // !!! проверить
      else history.back() // this.$router.go(-1)
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  width: 100%;
  margin: 0px 0px 0px 0px;
  padding: 0px;
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
}
.back-button {
  width: 100%;
  font-size: 35px;
  color: #777;
  padding: 10px 10px 10px 15px;
  cursor: pointer;
  float: left;
}
.back-button-over {
  width: 40px;
  position: relative;
  top: 5px;
  left: 7px;
  font-size: 35px;
  color: #fff;
  text-shadow: -1px 0 #777, 0 1px #777, 1px 0 #777, 0 -1px #777;
  cursor: pointer;
  float: left;
}
.back-button-over-right {
  width: 40px;
  position: relative;
  top: 5px;
  left: calc(100% - 85px);
  font-size: 35px;
  color: #fff;
  text-shadow: -1px 0 #777, 0 1px #777, 1px 0 #777, 0 -1px #777;
  cursor: pointer;
  float: left;
}
@media screen and (min-width: 1000px) {
  .back-button-over {
    top: 10px;
    left: 12px;
    color: #888;
    text-shadow: 0 0 #fff;
  }
  .back-button-over-right {
    top: 10px;
    left: calc(100% - 100px);
    color: #888;
    text-shadow: 0 0 #fff;
  }
}
.loading-text {
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
  font-size: 20px;
  padding: 20px 20px 20px 20px;
}
.eventnotfound-text {
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  font-size: 20px;
  padding: 20px 20px 20px 20px;
}
.event {
  width: 100%;
  max-width: 1200px;
  padding-bottom: 40px;
  float:left;
}
.event_part1 {
  width: 100%;
  max-width: 1200px;
  float:left;
}
.event_part2 {
  width: 100%;
  max-width: 1200px;
  margin-top: 30px;
  float:left;
}
@media screen and (min-width: 1000px) {
  .event {
    width: 650px;
    margin-left: calc((100% - 650px) / 2);
  }
  .event_part1 {
    max-width: 650px;
    text-align: left;
  }
  .event_part2 {
    max-width: 650px;
  }
}
.event-image {
  width: 100%;
  height: 66vw;
  max-height: 400px;
  background-size: cover;
  background-position: center;
  border-radius: 20px 20px 20px 20px;
  border-bottom: solid 1px #e0e0e0;
  cursor: pointer;
  float: left;
}
@media screen and (min-width: 1000px) {
  .event-image {
    width: 450px;
    height: 450px;
    max-height: 450px;
    margin-top: 25px;
    margin-left: 100px;
    border-radius: 225px;
    border: solid 1px #e0e0e0;
  }
}
.event-name {
  /* top: calc(100% - 105px); */
  /* position: relative;
  top: calc(100% - 120px);
  left: calc(15% - 20px);
  width: calc(70% - 40px);
  padding: 20px 20px 20px 20px;
  opacity: 1.0; */
  width: 100%;
  padding: 7px 25px 0px 25px;
  background: #fff;
  color: #333;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  text-align: left;
  border-right: solid 0px #000;
  border-radius: 10px 10px 10px 10px;
  float:left;
}
@media screen and (min-width: 1000px) {
  .event-name {
    text-align: center;
  }
  .event-status {
    text-align: center;
  }
}
.event-status {
  width: calc(100% - 50px);
  margin: 0px 25px 0 25px;
  padding: 5px 5px 5px 5px;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 16px;
  background: #d33;
  color: #fff;
  border-radius: 8px 8px 8px 8px;
  float: left;
}
.event-prop {
  width: 100%;
  padding: 7px 25px 0px 25px;
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 15px;
  float:left;
}
.link {
  cursor: pointer;
}
.link:hover {
  color: #78b;
}
.event-place-image {
  width: 60px;
  height: 60px;
  margin-right: 10px;
  background: #555;
  background-size: cover;
  background-position: center;
  border-radius: 10px;
  border: solid 1px #e0e0e0;
  float: left;
}
.event-user-avatar {
  width: 60px;
  height: 60px;
  margin-right: 10px;
  background: #555;
  background-size: cover;
  background-position: center;
  border-radius: 30px;
  border: solid 1px #e0e0e0;
  float: left;
}
.event-user-avatar-small {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  background: #555;
  background-size: cover;
  background-position: center;
  border-radius: 20px;
  border: solid 1px #e0e0e0;
  float: left;
}
.event-user-text {
  width:calc(100% - 50px);
  float:left
}
.text-align-left {
  text-align:left;
}
.text-align-right {
  text-align:right;
}
.button-primary{
  width: calc((100% - 44px) / 2);
  margin: 10px 10px 20px 10px;
  /*background: #6770a6;*/
  border-radius: 15px;
  background: #6070dd;
  font-size: 16px;
}
.event-member {
  width: 100%;
  padding: 2px 25px 0px 25px;
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 16px;
  float:left;
}
pre {
  width: 100%;
  overflow: visible;
  margin: 0;
  padding: 0;
  background: #fff;
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 15px;
  border: 0px;
  white-space: pre-wrap;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// Event.vue?61b43924